module.exports = __webpack_public_path__ + "media/5.7c8941d1.wav";